import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router";
import Grid from "@mui/material/Grid2";
import { defaultVariables } from "../../../../../config";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { Link, useNavigate } from "react-router-dom";
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../../config/design/styles";
import { connect } from "trim-redux";
import RayaField from "../../../../components/elements/fields/RayaField";
import { Card, MenuItem, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import {ChevronLeft, ChevronRight, CircleSlash2, Store} from "lucide-react";
import {currencySymbol, getDisplayDate, getMediaURL, price} from "../../../../../config/values";
import Avatar from "@mui/material/Avatar";
import NothingFound from "../../../../components/elements/NothingFound";

const CourierOrders = (props) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dateFilter, setDateFilter] = useState('all');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedOrders, setSelectedOrders] = useState([]);

    const navigation = useNavigate();
    let { id } = useParams();

    if (!id && !props.create) {
        if (!!props.user) {
            id = props.user.id;
        } else {
            navigation('/');
        }
    }

    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };

    const loadData = () => {
        setLoading(true);
        axios
            .get(`${defaultVariables.url}/couriers/orders/${id}?date=${dateFilter}`, config)
            .then((response) => {
                setData(response.data);
                setLoading(false);
            })
            .catch((error) => console.error(error));
    };

    useEffect(() => {
        loadData();
    }, [id,dateFilter]);

    const handleDateChange = (e) => {
        setDateFilter(e.target.value);
    };

    const handleOpenDialog = (orders) => {
        setSelectedOrders(orders);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setSelectedOrders([]);
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, md: 6, lg: 2 }}>
                            <RayaField
                                select
                                fullWidth
                                label={t('timeRange')}
                                value={dateFilter}
                                onChange={handleDateChange}
                            >
                                <MenuItem value="all">{t('all')}</MenuItem>
                                <MenuItem value="today">{t('today')}</MenuItem>
                                <MenuItem value="yesterday">{t('yesterday')}</MenuItem>
                                <MenuItem value="this_month">{t('thisMonth')}</MenuItem>
                                <MenuItem value="prev_month">{t('prev_month')}</MenuItem>
                                <MenuItem value="last_30_days">{t('last_30_days')}</MenuItem>
                            </RayaField>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item size={12}>
                    {loading ? (
                        <AppCardLoaderFields />
                    ) : (
                        <Grid container spacing={2}>
                            {data.map((item, index) => (
                                <Grid key={index} item size={{ xs: 12, md: 4, lg: 3 }}>
                                    <Card className="item-card bg-card p-3">
                                        {item.shop && (
                                            <div className="flex-direction mb-10">
                                                <Avatar src={getMediaURL(item.shop.logo,'small')} alt={item.shop.name} style={{width:40,height:40}}/>
                                                <Link to={`/panel/manage/shops/edit/${item.shop.id}`} style={{ marginLeft: 4 }}>
                                                    {item.shop.name}
                                                </Link>
                                                <ChevronRight className="lucide-small-narrow" />
                                            </div>
                                        )}


                                        <Typography variant="body2" gutterBottom>
                                            {t('ordersCount')}: <strong>{item.orders_count}</strong>
                                        </Typography>
                                        <Typography variant="body2" gutterBottom>
                                            {t('totalTransferPrice')}: <strong>{price(item.total_transfer_price)} {currencySymbol}</strong>
                                        </Typography>
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            sx={{ mt: 2 }}
                                            onClick={() => handleOpenDialog(item.orders)}
                                        >
                                            {t('ordersList')}
                                        </Button>
                                    </Card>
                                </Grid>
                            ))}
                            {
                                data.length === 0 &&
                                <Grid  item size={{ xs: 12}}>
                                    <NothingFound
                                        type="page"
                                        title={t('nothingFound')}
                                        title_color="text"
                                        paragraph={t('noOrderFoundDec')}
                                        icon={<CircleSlash2/>}
                                    >
                                        <Button
                                            variant="outlined"
                                            startIcon={<ChevronLeft/>}
                                            component={Link}
                                            to={`/`}
                                        >
                                            {t('back')}
                                        </Button>
                                    </NothingFound>
                                </Grid>
                            }
                        </Grid>
                    )}
                </Grid>
            </Grid>

            {/* Dialog for Order List */}
            <Dialog open={dialogOpen} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                <DialogTitle>{t('orders')}</DialogTitle>
                <DialogContent dividers>
                    {selectedOrders.length > 0 ? (
                        selectedOrders.map((order, idx) => (
                            <Typography key={idx} variant="body2" gutterBottom>
                                <Link className='primary-color' to={`/panel/manage/view-order/${order.number}`}>#{order.number}</Link> - {t(order.status)} - {getDisplayDate(order.created_at)} - {price(order.total_price_paid)} {currencySymbol}
                            </Typography>
                        ))
                    ) : (
                        <Typography variant="body2">{t('no_orders')}</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>{t('close')}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(CourierOrders));
